import React from "react";
import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Spinner as LoftSpinner } from "@xometry/xometry_loft";

export const YoutubeBase = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin: 2rem 0;
`;

export const YoutubeIFrame = styled.iframe<{ show: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${theme.rounded["2xl"]};
  transition: all 1.5s;
  opacity: ${(props) => (props.show ? "1" : "0")};
  overflow: hidden;
  box-shadow: ${theme.shadow.lg};
`;

export const ThumbnailContainer = styled.div<{ hide: boolean }>`
  width: 100%;
  height: 100%;
  background: ${theme.colors.darkBlues[25]};
  border-radius: ${theme.rounded["2xl"]};
  cursor: pointer;
  position: relative;
  z-index: ${(props) => (props.hide ? "0" : "100")};
  overflow: hidden;
  box-shadow: ${theme.shadow.lg};
`;

export const ThumbnailImage = styled.img`
  display: block;
  border-radius: 8px;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const Spinner = () => {
  return (
    <LoftSpinner
      style={{
        margin: `initial !important`,
        width: `initial !important`,
        position: `absolute`,
        top: `calc(50% - 35px)`,
        left: `calc(50% - 35px)`,
        zIndex: 1000,
      }}
    />
  );
};

export const PlayerButton = styled.svg`
  width: 68px;
  height: 48px;
  position: absolute;
  margin: 0 auto;
  top: calc(50% - 24px);
  left: calc(50% - 34px);

  path:first-of-type {
    fill: #212121;
    fill-opacity: 0.8;
  }

  .thumbnail-container:hover & {
    path:first-of-type {
      fill: #f00;
      fill-opacity: 1;
    }
  }
`;
